import { BaseEntity } from '../../base-entity';

export enum PaymentInstallmentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export interface PaymentInstallmentEntity extends BaseEntity {
  id: number;
  installmentPlanId: number;
  installmentNumber: number;
  dueDate: Date;
  amount: number;
  status: PaymentInstallmentStatus;
  userPaymentId: number | null;
  paidAt: Date | null;
}

export interface PaymentInstallmentPlanEntity extends BaseEntity {
  id: number;
  userId: number;
  totalAmount: number;
  branchId: number | null;
  numberOfInstallments: number;
  firstPaymentDate: Date;
  paymentDayOfMonth: number;
  status: string;
  cancelledAt: Date | null;
  cancelledBy: number | null;
  cancelledReason: string | null;
  creditCardTokenId: number | null;
}

export interface PaymentInstallmentPlanItemEntity extends BaseEntity {
  id: number;
  installmentPlanId: number;
  userAllocationId: number;
  allocationAmount: number;
}

export interface InstallmentWithPlanItemsDetails {
  installment: PaymentInstallmentEntity[];
  installmentPlan: PaymentInstallmentPlanEntity;
  paymentInstallmentPlanItemAllocations: PaymentInstallmentPlanItemEntity[];
}
